import { render, staticRenderFns } from "./reportings-app.vue?vue&type=template&id=361d6427"
import script from "./reportings-app.vue?vue&type=script&lang=js"
export * from "./reportings-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports